import request from '@/utils/request'

// 获取团队成员列表
export function getTeamList(params) {
  return request({
    url: '/move/getBusinessTeam',
    method: 'get',
    params
  })
}

// 添加团队成员
export function addTeamMember(data) {
  return request({
    url: '/move/addUserBusiness',
    method: 'post',
    data
  })
}

// 移除团队成员
export function removeTeamMember(params) {
  return request({
    url: '/move/delBusinessTeam',
    method: 'delete',
    params
  })
}

// 搜索用户
export function searchUsers(params) {
  return request({
    url: '/user/getUserList',
    method: 'get',
    params: params 
  })
} 